import React, { useEffect, useState } from 'react';

export default function PlayLabel (props) {
  return (
    <div className="mb_play_w">
      <span className="icon_mb_play">
        <svg xmlns="http://www.w3.org/2000/svg" width="10.667" height="16" viewBox="0 0 10.667 16">
          <path d="M6.75,3.656v16l10.667-8Z" transform="translate(-6.75 -3.656)"></path>
        </svg>
      </span>
      <i className="ir">play</i>
    </div>
  );
}